import React from 'react'
import { November } from 'component-library/collections-new/November/November'
import { ContentDataDefinitionLoader } from 'common/data/loader-definitions'
import {
    CollectionRouteProps,
    calculateExpectedCardCountFromContentData,
} from 'component-library/collections-new/collections-props.routing'
import { Section } from 'component-library/__styling/settings/sections'
import { LoadMore } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { LoadMoreProps } from 'component-library/collections-new-loadmore/LoadMore/LoadMore'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { isPublicationCardItem } from 'common/client-data-types/card-types'
import { TimestampType } from 'component-library/content/CardTimestamp/CardTimestamp'

export interface NovemberRouteProps extends CollectionRouteProps, LoadMoreProps {
    collectionSection?: Section
    timestamp?: TimestampType
    truncateListCards?: boolean
    hasBackground?: boolean
    contentIsTangential?: boolean
}

export const NovemberRegistration = createRegisterableComponentWithData(
    'november',
    ContentDataDefinitionLoader,
    (props: NovemberRouteProps, data, services) => {
        return (
            <LoadMore
                dataDefinition={data.dataDefinitionArgs}
                services={services}
                loadMoreEnabled={props.loadMoreEnabled === true}
                data={data}
                render={loadMoreData => {
                    return (
                        <November
                            items={
                                loadMoreData.loaded
                                    ? {
                                          loaded: true,
                                          result: loadMoreData.result.publications.filter(
                                              isPublicationCardItem
                                          ),
                                      }
                                    : { loaded: false }
                            }
                            expectedCards={calculateExpectedCardCountFromContentData(
                                data.dataDefinitionArgs
                            )}
                            sectionHeader={props.sectionHeader}
                            section={props.collectionSection}
                            timestamp={props.timestamp}
                            onEvent={services.onEvent}
                            verticalSpacing={props.verticalSpacing}
                            truncateListCards={props.truncateListCards}
                            hasBackground={props.hasBackground}
                            contentIsTangential={props.contentIsTangential}
                        />
                    )
                }}
            />
        )
    }
)
